import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { LandingSvg } from 'assets';

export const PowerfulFeaturesCard = ({
                                         Icon,
                                         iconColor,
                                         iconHoverColor,
                                         hoverColor,
                                         featureTitle,
                                         featureDescription,
                                         navigatePath,
                                     }) => {
    const [hover, setHover] = useState(false);
    const navigate = useNavigate();

    return (
        <div
            className="powerful-feature-card-block"
            onMouseEnter={() => setHover(true)}
            onMouseLeave={() => setHover(false)}
            style={{
                background: hover ? hoverColor : '',
            }}
        >
            <div className="powerful-feature-card-icon-wrapper">
                <Icon
                    style={{
                        filter: hover ? iconHoverColor : iconColor,
                    }}
                />
            </div>

            <div className="powerful-feature-card-title_description-btn">
                <div className="powerful-feature-card-title_description">
                    <h3 className="powerful-feature-card-title">{featureTitle}</h3>

                    <p className="powerful-feature-card-description">{featureDescription}</p>
                </div>

                <button
                    className="all-features-btn"
                    onClick={() => navigatePath && navigate(navigatePath)}
                >
                    Discover More
                    <LandingSvg.ArrowRightSvg className="arrow-right" />
                </button>
            </div>
        </div>
    );
};
